import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs as Abas } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import TabBONE from "./TabBONE";
import TabECC from "./TabECC";
import TabEmpresa from "./TabEmpresa";
import TabViceri from "./TabViceri";
import TabVolumetria from "./TabVolumetria";

function Tabs({
	touched,
	values,
	errors,
	handleChange,
	initValues,
	setFieldValue,
	formik,
	onTestConnect,
	connected,
	isLoading
}) {
	const [tabIndex, setTabIndex] = useState(0);
	const { initViceri, initEcc } = initValues;
	return (
		<ModernContainer>
			<Abas selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
				<TabList>
					<Tab>Empresa</Tab>
					<Tab>B1</Tab>
					<Tab>ECC</Tab>
					<Tab>Configuração</Tab>
					<Tab>Volumetria</Tab>
				</TabList>
				<TabPanel>
					<TabEmpresa
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
					/>
				</TabPanel>
				<TabPanel>
					<TabBONE
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
						initialValues={initViceri}
						onTestConnect={onTestConnect}
						connected={connected}
						isLoading={isLoading}
					/>
				</TabPanel>
				<TabPanel>
					<TabECC
						touched={touched}
						values={values}
						errors={errors}
						setFieldValue={setFieldValue}
						handleChange={handleChange}
						initialValues={initEcc}
					/>
				</TabPanel>
				<TabPanel>
					<TabViceri
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
						initialValues={initViceri}
					/>
				</TabPanel>
				<TabPanel>
					<TabVolumetria
						touched={touched}
						values={values}
						errors={errors}
						handleChange={handleChange}
						initialValues={initViceri}
					/>
				</TabPanel>
			</Abas>
		</ModernContainer>
	);
}

const ModernContainer = styled.div`
	width: 100%;
	font-family: 'Mulish', sans-serif;

	.react-tabs {
		-webkit-tap-highlight-color: transparent;
	}

	.react-tabs__tab-list {
		border-bottom: 2px solid #e2e8f0 !important;
		margin: 0 0 24px !important;
		padding: 0 !important;
		display: flex !important;
		gap: 8px !important;
		flex-wrap: wrap !important;
	}

	.react-tabs__tab {
		padding: 12px 24px !important;
		border: none !important;
		background: transparent !important;
		cursor: pointer !important;
		font-size: 14px !important;
		font-weight: 600 !important;
		color: #64748b !important;
		border-bottom: 3px solid transparent !important;
		transition: all 0.3s ease !important;
		font-family: 'Mulish', sans-serif !important;
		outline: none !important;
		list-style: none !important;
		position: relative !important;
		margin: 0 !important;

		&:hover {
			color: #667eea !important;
			background: rgba(102, 126, 234, 0.05) !important;
			border-radius: 8px 8px 0 0 !important;
		}
	}

	.react-tabs__tab--selected {
		color: #667eea !important;
		border-bottom-color: #667eea !important;
		background: rgba(102, 126, 234, 0.05) !important;
		border-radius: 8px 8px 0 0 !important;
	}

	.react-tabs__tab--disabled {
		color: #cbd5e1 !important;
		cursor: not-allowed !important;

		&:hover {
			color: #cbd5e1 !important;
			background: transparent !important;
		}
	}

	.react-tabs__tab:focus {
		box-shadow: none !important;
	}

	.react-tabs__tab-panel {
		display: none !important;
		animation: fadeIn 0.3s ease !important;
	}

	.react-tabs__tab-panel--selected {
		display: block !important;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export default Tabs;
